import React, { Component } from 'react';
import { trackError } from '@vend/utilities';
import { ErrorPage } from '../errorPage/ErrorPage';
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true });
        trackError(error, errorInfo);
    }
    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }
        if (this.props.errorComponent) {
            return this.props.errorComponent;
        }
        return React.createElement(ErrorPage, null);
    }
}
